// @index(!types)
export {default as ParticipantDocument} from './ParticipantDocument'
// /index